import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { FormattedMessage } from 'react-intl';

import { PhoneDetails } from '@clients/accountsClient';
import useEditPhone from '@hooks/queries/useEditPhone';

import PhoneForm from './PhoneForm';

interface UserEditModalProps {
    phoneNumberDetail?: PhoneDetails;
    onClickClose: () => void;
}

const PhoneEditModal = ({
    phoneNumberDetail,
    onClickClose,
}: UserEditModalProps) => {
    const defaultValues = {
        type: phoneNumberDetail?.type,
        countryCode: phoneNumberDetail?.country_code.toString(),
        areaCode: phoneNumberDetail?.area_code.toString(),
        number: phoneNumberDetail?.number,
        extension: phoneNumberDetail?.extension,
    };

    const { mutate, isLoading } = useEditPhone(
        phoneNumberDetail.account_id,
        phoneNumberDetail.id,
        () => {
            handleCloseForm();
        },
    );

    const handleCloseForm = () => {
        onClickClose();
    };

    return (
        <PDialog
            open
            dialogTitle={
                <FormattedMessage
                    id="phoneEditDialog.editDetails"
                    defaultMessage="Edit details"
                />
            }
            dialogSubtitle={
                <FormattedMessage
                    id="phoneEditDialog.editDetailsSubheader"
                    defaultMessage="You can edit the details by changing the input fields below then clicking save."
                />
            }
            onClose={onClickClose}>
            <PhoneForm
                onClickClose={handleCloseForm}
                mutate={mutate}
                isLoading={isLoading}
                defaultValues={defaultValues}
            />
        </PDialog>
    );
};

export default PhoneEditModal;
